import { render } from "./GamesSection.vue?vue&type=template&id=2d37ef18"
import script from "./GamesSection.vue?vue&type=script&lang=js"
export * from "./GamesSection.vue?vue&type=script&lang=js"

import "./GamesSection.vue?vue&type=style&index=0&id=2d37ef18&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/mobil-maszofal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__